// START Open Requre.JS wrapper
define([
	'jquery',
	'pubsub',
	'shared.main.screen',
	'wcs.utils'
], function($,pubsub,screenSize,utils) {
// END Open Require.JS wrapper

	var DEBUG = false;
	var PLUGIN_IDENTIFIER = "topnavAccordion";
	var topnavAccordion;
	var aemTopnavAccordionEnabled = WCS_CONFIG.get('topnav::aemTopNavAccordionEnabled') || false;
	var aemTopnavStyleContainerEnabled = WCS_CONFIG.get('topnav::aemTopnavStyleContainerEnabled') || false;
	var topnavOverlayContentEnabled = WCS_CONFIG.get('topnav::topnavOverlayContentEnabled') || false;
	var topNavMenuBackButtonOverrideEnabled = WCS_CONFIG.get('topnav::topnavMenuBackButtonTextOverrideEnabled') || false;
	var enableMobileTopNavForTablet = WCS_CONFIG.get('topnav::enableMobileTopNavForTablet') || false;
	var renderTopNavForVansEU = WCS_CONFIG.get('topnav::renderTopNavForVansEU') || false;
	var isTabletDevice = (window.devicePixelRatio >= 2 && (window.innerWidth >= 640 && window.innerWidth <= 1024)) && enableMobileTopNavForTablet;
	
	(function(){

		/****
		 * Shows/hides navigation l2s & l3s by clicking the accordion links
		 * visible on small devices.
		 ***/
		topnavAccordion = {
			defaults: {
				dataAttr: "menu-button-options",
				accordionLink: '.topnav-accordion .has-children > a',
				topNavDropdown: '.topnav-dropdown',
				accordion: '.topnav-accordion',
				accordionItem: '.topnav-accordion-item',
				l1ShopAll: '.topnav-accordion-shopall:not(".l2 .topnav-accordion-shopall")',
				speed: 250,
				easing: 'swing',
				imageGrid: '.topnav-dropdown-imagegrid',
				drilldown: 'topnav-drilldown',
				drilldownMenu: '.drilldown-menu',
				drilldownContainer : '.drilldown-container',
				drilldownBackLink : '.drilldown-back-link',
				drodownWrapper: '.topnav-dropdown-wrapper',
				shopAll: 'topnav-accordion-shopall',
				shopAllLink: 'topnav-accordion-shopall-link',
				mainNavContainer: '.mainnav-content',
				carouselContainer: '.carousel-section'
			},

			/**
			 * Initialize Main Menu Accordion
			 **/
			init : function() {
				if ( DEBUG ) console.log('initilizing ' + PLUGIN_IDENTIFIER);

				var self = this; // Make plugin namespace available throughout
				self.deferred = $.Deferred();

				self.$element = $(self.defaults.accordion);
				self.metadata = self.$element.data(self.defaults.dataAttr);
				self.config = $.extend( {}, self.defaults, self.metadata );

				self.defaultMenuType = "accordion";
				self.$carouselCollection = $(this.config.carouselContainer);
				self.$carouselCollection.addClass('hide');

				self.$menu = self.$element;
				self.menuType = self.$menu.data('mobile-menu-type');
				self.l2Counter = 0;
				self.l3Counter = 0;
				self.boundToElement = false;
				self.$accordion = $(self.config.accordion);
				self.$mainnav = $(self.config.mainnav);

				if(self.menuType === "drilldown") {
					self.$drilldownContainer = self.$menu.find(self.config.drilldownContainer);
					self.$drilldownMenus = self.$drilldownContainer.find(self.config.drilldownMenu);
					self.$drilldownRoot = self.$drilldownMenus.filter('.root');
					self.$drilldownBackLinks = self.$drilldownContainer.find(self.config.drilldownBackLink);
					self.enableDrilldownMenu();
				}

				self.events();

				self.handleWhatsTheStyleContentPosition();
				self.menuStatus = 'inactive';

				self.deferred.resolve();
				if (aemTopnavAccordionEnabled) {
					self.removeTooltip();
				}

				if (topnavOverlayContentEnabled) {
					self.setupOverlayEffect();
				}

				return self;
			},

			/**
			 * Initilize specific plugins
			 **/
			events : function() {
				var self = this;

				$(self.config.accordionLink).on('click touch', $(this), function(e) {
					$(".custom-highlights").removeClass("custom-highlights");
					self.setCarouselCollectionVisibility($(this).parent().find(self.config.drilldownMenu).first());
					if (screenSize.size() === "small" || isTabletDevice) {
						e.preventDefault();
						$(this).parent().find(".expand-highlights").addClass("custom-highlights");
						if(!$(this).hasClass("expand-highlights"))
							self.toggleMenu($(this));
					}
				});

				$.pubsub('subscribe','window.resize.breakpoint',function(event,data) {
					if(data.now !== 'small' && !isTabletDevice) {
						self.resetMenu(self.$accordion);
					}

					// re-configure drilldown menu when breakpoint changes
					if(self.menuType === "drilldown") {
						if(data.now === 'small' || isTabletDevice) {
							self.enableDrilldownMenu();
						}
						else {
							self.disableDrilldownMenu();
						}
					}

					self.toggleKeyboardMenuEvents(self.$accordion);
				});

				if(self.menuType === "drilldown") {
					// drilldown back links are only visible on small screens
					self.$drilldownBackLinks.on('click touch', function(e) {
						e.preventDefault();
						self.goToPrevMenu();
					});
				}

				// Bind keyboard events to all items in the menu
				self.toggleKeyboardMenuEvents(self.$accordion);

				$.pubsub('subscribe', 'vfdp.aem.topnav.accordion.close', function() {
					self.resetMenu(self.$accordion);
				});
                if(aemTopnavAccordionEnabled) {
					$('#topnav-menu-button').on('click', function(e) {
						self.setDrilldownHeight();
					});
				}
			},

			setupOverlayEffect: function() {
				var self = this,
					$bodyContainer = $('#body-container'),
					$menuItem = $('.l1.topnav-accordion-item');

				$bodyContainer.addClass('overlay-enabled');

				$menuItem
					.on('mouseover', function(event) {
						var $item = $(this);

						if ($item.hasClass('has-children')) {
							$bodyContainer.addClass('overlay-active');
						}
					})
					.on('mouseout', function(event) {
						$bodyContainer.removeClass('overlay-active');
					});

			},

			removeTooltip: function() {
				$('.topnav-accordion-item-link').removeAttr('title');
				$('.topnav-utility-item-link').removeAttr('title');
				$('.topnav-utility-item--flag-link').removeAttr('title');
			},

			toggleKeyboardMenuEvents: function(el) {
				var self = this;
				el.off('keydown', self, self.topnavMenuKeyDownHandler);
				self.boundToElement = false;
				if(screenSize.size() === "small" || isTabletDevice) {
					el.on('keydown', self, self.topnavMenuKeyDownHandler);
					self.boundToElement = true;
				}
			},

			toggleMenu: function(el) {
				var self = this;
				if(el.parent().hasClass('active')) {
					self.hideMenuLinks(el);
				}
				else {
					// Hiding the Top Nav, if we have Drilldown menus
					if(aemTopnavAccordionEnabled) {
						$('#topnav-accordion').addClass("topnav-accordion-top");
					} else {
						$('#topnav-accordion').removeClass("topnav-accordion-top");
					}
					self.showMenuLinks(el);
				}
			},

			showMenuLinks: function(el) {
				var self = this,
					$topNavMenuDropdown,
					$closestLi = el.parent(),
					li = $closestLi.get(0),
					sectionHeight = 0;

				// Drilldown
				if(self.menuType === "drilldown") {
					self.goToNextMenu($closestLi.find(self.config.drilldownMenu).first());
					return;
				}

				// identify the dropdown container based on navigation level
				if(el.closest('li').hasClass('l1')) {
					$topNavMenuDropdown = $closestLi.find(self.config.topNavDropdown);
				} else {
					$topNavMenuDropdown = el.siblings();
				}

				el.attr({'aria-expanded':'true'});

				// Callback for when animation completes
				var animationComplete = function() {
					$topNavMenuDropdown.height('auto').addClass('active');
					$closestLi.height('auto');
					// remove this event listener so it only gets triggered once
					li.removeEventListener('transitionend', animationComplete);
				};

				// Setup event listener for the css transition finishes
				li.addEventListener('transitionend', animationComplete);

				utils.interruptTransitions($closestLi, function() {
					// add active class to l1, set dropdown visible
					$closestLi.css({
						height: 0,
						overflow: 'hidden',
						display: 'block'
					}).addClass('active');
					$topNavMenuDropdown.css({display: 'block'});

					// get height of li
					sectionHeight = li.scrollHeight;
				});

				// set the height for css transition
				li.style.height = sectionHeight + 'px';
			},

			hideMenuLinks: function(el) {
				var self = this,
					$closestLi;

				// if l1, animate on dropdown, otherwise animate on li element
				if(el.closest('li').hasClass('l1')) {
					$closestLi = el.closest('.l1');
				} else {
					$closestLi = el.closest('.l2');
				}

				var li = $closestLi.get(0);
				var sectionHeight = li.scrollHeight;
				var targetedHeight = (el.height() + (parseInt(el.parent().css('padding-top')) * 2));

				el.attr({'aria-expanded':'false'});

				var animationComplete = function() {

					// remove any active class within the li (includes the dropdown)
					$closestLi.find('.active').css({
						display: '',
						height: '',
						overflow: ''
					}).removeClass('active');

					// $topNavAccordionDropdown.css({display: 'none'}).removeClass('active');
					$closestLi.removeClass('active').css({
						'display':'',
						'height':'',
						'overflow': ''
					});
					// remove this event listener so it only gets triggered once
					li.removeEventListener('transitionend', animationComplete);
				};

				// on the first frame explicitly set the element's height to its current pixel height,
				// so we aren't transitioning out of 'auto'
				requestAnimationFrame(function() {
					utils.interruptTransitions($closestLi, function() {
						// set the element's height to its current pixel height before restoring transitions
						li.style.height = sectionHeight + 'px';
					});

					// on the next frame (as soon as the previous style change has taken effect)
					// setup the complete listener and trigger the transition
					requestAnimationFrame(function() {
						li.addEventListener('transitionend', animationComplete);

						// Start regular transition height to 0
						li.style.height = targetedHeight + 'px';
					});
				});
			},

			resetMenu: function(el) {
				var self = this;

				el.find('.active').css({
					'display': '',
					'height': '',
					'padding-top': ''
				}).removeClass('active');
				el.find(self.config.l1ShopAll).css({'display': ''});

				if(self.menuType === "drilldown") {
					self.resetDrilldownMenu();
				}
			},

			navigate: function(counter, categoryIndexes, keyCode) {
				if(keyCode == 40)
				{
					$('[tabindex=' + categoryIndexes[counter] + ']').trigger( "focus" );
					counter++;
				}
				else
				{
					counter--;
					$('[tabindex=' + categoryIndexes[counter] + ']').trigger( "focus" );
				}
				return counter;
			},

			navigateL1: function(link, parentl1, parentl2, l1Children, l2Children) {
				var self = this;
				if(link.length)
				{
					link.trigger( "focus" );
				}
				else
				{
					parentl1.find('> a').trigger( "focus" );
				}
				if(parentl1.hasClass('active'))
				{
					self.hideMenuLinks(l1Children);
					if(parentl2.hasClass('active'))
					{
						self.hideMenuLinks(l2Children);
					}
				}
			},

			collapseDropdown: function(focusedElement) {
				var self = this;
				self.hideMenuLinks(focusedElement);
				focusedElement.closest('.l1').children('a').trigger( "focus" );
			},

			/**
			* Handles keyboard events and dropdown elements
			* for user accessibility interactions
			* @param event JQuery Event
			**/
			topnavMenuKeyDownHandler: function(event) {
				var self = event.data,
					$this = $(this),
					$focusedLink = $this.find($(":focus")), // the <a> in the nagivation
					$focusedParent = $focusedLink.parent(), // the <li> wrapping the focused <a>
					hasChildren = $focusedParent.hasClass('has-children'),
					keys = {
						down: 40,
						enter: 13,
						esc: 27,
						left: 37,
						right: 39,
						space: 32,
						tab: 9,
						up: 38
					};
				switch(event.keyCode) {

					// *** ENTER or SPACE ***
					// If item is an accordion, toggles an accordion section open or closed
					case keys.space:
					case keys.enter:
						if(hasChildren) {
							event.preventDefault();
							if($focusedParent.hasClass('active')) {
								self.hideMenuLinks($focusedLink);
							}
							else {
								self.showMenuLinks($focusedLink);
							}
						}
					break;

					// *** DOWN ARROW ***
					// When focus is on an accordion header, moves focus to the next accordion header
					// When focus is on last accordion header, moves focus to first accordion header or shop all link
					// Focus should cycle through the current accordion
					case keys.down:
						event.preventDefault();

						var $next = $focusedParent.next();

						// Skip the L1 more menu item and go back to the first L1 link
						if($next.hasClass('more')) {
							$next = $focusedParent.siblings().first();
						}

						// Move focus from shop all link to first category link
						else if($focusedLink.hasClass(self.config.shopAllLink)) {
							// get the first L3 link
							if($focusedParent.hasClass(self.config.shopAll)) {
								$next = $focusedParent.siblings().find('.l3').first();
							}
							// get the first L2 link
							else {
								$next = $focusedParent.closest(self.config.drodownWrapper).find('.l2').first();
							}
						}

						// Move focus from the last L2 link in a column to the first L2 link in next column
						else if($focusedParent.hasClass('l2') && $focusedParent.is(':last-child')) {
							var $col = $focusedParent.closest('.columns'),
								$nextCol = $col.next();

							// Move focus from last column back to shop all link or first L2
							// If the promo column is enabled it will always be the last column but is
							// usually hidden on small screens and should then be skipped here
							if ($col.is(':last-child') || $nextCol.is(':hidden:last-child')) {
								$next = $focusedParent.closest(self.config.drodownWrapper).find('.' + self.config.shopAll + ' .columns');

								// if there is no shop all link, go to the first L2 link
								if(!$next.length) {
									$next = $col.siblings().first().find('.l2').first();
								}
							}
							// Move to next column
							else {
								$next = $nextCol.find('.l2').first();
							}
						}

						// Move focus from the last L3 link back to the shop all link or first L3 link in next column
						else if ($focusedParent.hasClass('l3') && $focusedParent.is(':last-child')) {
							$next = $focusedParent.closest('.l2').find('.' + self.config.shopAll);

							// if there is no shop all link, go to the first L3 link
							if(!$next.length) {
								$next = $focusedParent.siblings().first();
							}
						}

						$next.find('> a').focus();
					break;

					// *** UP ARROW ***
					// When focus is on an accordion header, moves focus to the previous accordion header
					// When focus is on first accordion header, moves focus to last accordion header
					// Focus should cycle through the current accordion
					case keys.up:
						event.preventDefault();

						var $prev = $focusedParent.prev();

						// Skip the L1 more menu item and go L1 link before it
						if($focusedParent.hasClass('l1') && $focusedParent.is(':first-child')) {
							$prev = $focusedParent.siblings().last();
							if($prev.hasClass('more')) {
								$prev = $prev.prev();
							}
						}

						// Move focus from shop all link to last category link
						else if($focusedLink.hasClass(self.config.shopAllLink)) {
							// get the last L3 link
							if($focusedParent.hasClass(self.config.shopAll)) {
								$prev = $focusedParent.siblings().find('.l3').last();
							}
							// get the last L2 link
							else {
								var $lastCol = $focusedParent.closest(self.config.drodownWrapper).find('>.row .columns').last();
								$prev = $lastCol.find('.l2').last();

								// If the promo column is enabled it will always be the last column but is
								// usually hidden on small screens and should then be skipped here
								if($lastCol.is(':hidden')) {
									$prev = $lastCol.prev().find('.l2').last();
								}
							}
						}

						// Move focus from the first L2 link in a column to the last L2 link in previous column or shop all link
						else if($focusedParent.hasClass('l2') && $focusedParent.is(':first-child')) {
							var $currentCol = $focusedParent.closest('.columns');
							var $prevCol = $currentCol.prev();

							// Move focus from first column back to shop all link or last L2
							if ($currentCol.is(':first-child')) {
								$prev = $focusedParent.closest(self.config.drodownWrapper).find('.' + self.config.shopAll + ' .columns');

								// if there is no shop all link, go to the last L2 link
								if(!$prev.length) {
									$prev = $currentCol.siblings().last().find('.l2').last();
								}
							}
							// Move to next column
							else {
								$prev = $prevCol.find('.l2').last();
							}
						}

						// Move focus from the first L3 link back to the shop all link or last L3 link in last column
						else if ($focusedParent.hasClass('l3') && $focusedParent.is(':first-child')) {
							$prev = $focusedParent.closest('.l2').find('.' + self.config.shopAll);

							// if there is no shop all link, go to the first L3 link
							if(!$prev.length) {
								$prev = $focusedParent.siblings().last();
							}
						}

						$prev.find('> a').focus();
					break;

					case keys.esc:
						event.preventDefault();
						var $parentAccordion = $focusedLink.closest(self.config.accordionItem + '.active');
						if($parentAccordion.length) {
							$parentAccordion.find('> a').focus();
							self.hideMenuLinks($parentAccordion);
						}
					break;
				}
			},

			/**
			 * Enable/Reset Drilldown Menu. Should only be enabled on Small Screens
			 **/
			enableDrilldownMenu: function() {
				var self = this;

				if(screenSize.size() === "small" || isTabletDevice) {
					// add drilldown menu classes to apply styling
					self.$accordion.addClass(self.config.drilldown);

					// reset menu
					self.resetDrilldownMenu();

					self.deferred.resolve();
				}

				return self.deferred;
			},

			/**
			 * Disable/Unset Drilldown Menu. Should not be disabled on Small Screens
			 **/
			disableDrilldownMenu: function() {
				var self = this;

				if(screenSize.size() !== "small" && !isTabletDevice) {
					// remove core drilldown menu class to remove styling
					self.$accordion.removeClass(self.config.drilldown);

					// reset menu
					self.resetDrilldownMenu();

					self.deferred.resolve();
				}

				return self.deferred;
			},

			/**
			 * Reset State of Drilldown Menu
			 **/
			resetDrilldownMenu: function() {
				var self = this;

				// hide any previously active menus
				self.$drilldownMenus.removeClass('active');

				// set drilldown to root level
				self.$drilldownRoot.attr("data-menu-level", 0);
				self.$drilldownActiveMenu = self.$drilldownRoot;
				self.setDrilldownHeight();
				self.handleWhatsTheStyleContentPosition();
			},

			/**
			 * Set the height on the Drilldown container to match the active menu
			 * because menus are absolutely positioned.
			 * Height should be unset on medium/large screens to not impact Topnav display
			 **/
			setDrilldownHeight: function() {
				var self = this;

				if(screenSize.size() === "small" || isTabletDevice) {
					// get the menu's size from the cached data property
					var height = self.$drilldownActiveMenu.data('height');

					// if the menu's size has not been cached yet, calculate its size and then cache it
					if (!height) {

						// get the menu's actual height
						height = self.$drilldownActiveMenu.outerHeight();

						// When the mobile menu or drilldown menu is closed/hidden, the height will be 0
						// so we need to use the below util to get the height
						if (height === 0) {
							// if the whole mobile menu is closed, pass it to the util as the parent
							var $parent = self.$accordion.is(':visible') ? null : self.$accordion;
							height = utils.getHiddenElementSize(self.$drilldownActiveMenu, $parent, renderTopNavForVansEU).height;
						}

						// cache the menu's height as a data property
						self.$drilldownActiveMenu.data('height', height);
						// adjusts height when "whats your style container" is enabled.
					}
					if (aemTopnavStyleContainerEnabled) {
						$(this.config.mainNavContainer).css({height: height + 47});
					} else {
						// set the height of the drilldown to the active menu's height
						self.$drilldownContainer.css({height: height});
					}
				}
				// unset the height on medium/large screens because drilldown only applies to small screens
				else {
					self.$drilldownContainer.css({ height: "" });
				}
			},

			goToNextMenu: function($menu) {
				var self = this;
				self.$drilldownActiveMenu = $menu;
				self.$drilldownActiveMenu.addClass('active');
				self.setDrilldownHeight();

				var level = parseInt(self.$drilldownRoot.attr('data-menu-level')) + 1;
				self.$drilldownRoot.attr('data-menu-level', level);

				// Set the L3 menu back-link text to the L1 category name when opened for the first time
				if(level == 1 && !self.$drilldownActiveMenu.attr('data-category')) {
					var category = self.$drilldownActiveMenu.siblings('.topnav-accordion-item-link').text();
					if(topNavMenuBackButtonOverrideEnabled) {
						category = self.$drilldownActiveMenu.find('.topnav-dropdown-wrapper .drilldown-back-text').first().text();
					}
					self.$drilldownActiveMenu.attr('data-category', category);
					self.$drilldownActiveMenu.find('.topnav-dropdown-l3 .drilldown-back-text').text(category);
				}
				if(aemTopnavAccordionEnabled) {
					$('.topnav-utility-small-container').addClass('hide');
				}
				self.handleWhatsTheStyleContentPosition();
			},

			goToPrevMenu: function() {
				var self = this;

				var previousMenu = self.$drilldownActiveMenu;
				self.$drilldownActiveMenu = previousMenu.parents(self.config.drilldownMenu).first();

				// If menu is level 1, showing the header top Navigation on Previous menu clicks
				if(aemTopnavAccordionEnabled)  {
					self.$drilldownActiveMenu.find(".expand-highlights").addClass("custom-highlights");
					var level = parseInt(self.$drilldownRoot.attr('data-menu-level'));
					if(level === 2){
						$('#topnav-accordion').addClass("topnav-accordion-top");
					} else {
						$('#topnav-accordion').removeClass("topnav-accordion-top");
						$('.topnav-utility-small-container').removeClass("hide");
					}
				}

				//make the carousel on the new active menu visible (if exists)
				self.setCarouselCollectionVisibility(self.$drilldownActiveMenu);

				// Callback for when animation completes
				var animationComplete = function() {
					previousMenu.removeClass('active');
					// remove this event listener so it only gets triggered once
					self.$drilldownRoot[0].removeEventListener('transitionend', animationComplete);
				};

				// Setup event listener for the css transition finishes
				self.$drilldownRoot[0].addEventListener('transitionend', animationComplete);
				self.setDrilldownHeight();
				self.$drilldownRoot.attr('data-menu-level', parseInt(self.$drilldownRoot.attr('data-menu-level')) - 1);

				self.handleWhatsTheStyleContentPosition();
			},

			handleWhatsTheStyleContentPosition: function() {
				if ( DEBUG ) console.log('handleWhatsTheStyleContentPosition');
				try {
					if (aemTopnavStyleContainerEnabled) {
						var self = this;
						var $whatsYourStyle = $('.whats-your-style-container');
						if ($whatsYourStyle.length > 0) {
							if (parseInt(self.$drilldownRoot.attr('data-menu-level')) === 0 ) {
							   self.$drilldownRoot.css('top','auto');
							} else {
								self.$drilldownRoot.css('top','0px');
							}
						}
					}
				} catch(err) {
					console.log(err);
				}
			},

			setCarouselCollectionVisibility: function($menu) {
				var self = this;

				self.$carouselCollection.addClass('hide');
				if (screenSize.size() === "small" || isTabletDevice) {
					// take the carousel only in the immediate active drilldown menu (not in any nested drilldown menus) and make it visible
					var allNestedResults = $menu.find(self.config.carouselContainer);
					var resultsInNestedChildrenMenusToBeExcluded = $menu.find(self.config.drilldownMenu + ' ' + self.config.carouselContainer);
					var carouselStrictlyInTheCurrentMenu = allNestedResults.not(resultsInNestedChildrenMenusToBeExcluded);
					carouselStrictlyInTheCurrentMenu.removeClass("hide");
				}
			}

		};

		return topnavAccordion.init();

	})();

	return topnavAccordion;

});
